import { configureStore } from '@reduxjs/toolkit'
import { authReducer } from './slices/authSlice'
import { modalReducer } from 'app/store/slices/modalSlice'
import { qrAuthReducer } from './slices/qrAuthSlice'
import { consultReducer } from 'app/store/slices/consultSlice'
import { networkReducer } from './slices/networkSlice'
import { errorReducer } from './slices/errorSlice'
import { uploadProgressReducer } from './slices/uploadProgressSlice'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        qrAuth: qrAuthReducer,
        consult: consultReducer,
        modal: modalReducer,
        network: networkReducer,
        error: errorReducer,
        uploadProgress: uploadProgressReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            // Enable serialization checks in development mode only
            // This helps catch non-serializable values (functions, Promises, class instances)
            // which can cause issues with Redux DevTools and state persistence
            // Disabled in production for performance
            serializableCheck:
                process.env.NODE_ENV !== 'production'
                    ? {
                          // Warn instead of error to avoid breaking existing functionality
                          warnAfter: 32,
                          // Ignore specific action types if needed (can be configured later)
                          ignoredActions: ['error/setRetryModal'],
                          // Ignore modal.children as it stores ReactNode (non-serializable)
                          // TODO: Refactor modal slice to use modal ID system instead
                          // Ignore error.retryModal.onRetry/onCancel as they store callback functions
                          ignoredPaths: [
                              'modal.children',
                              'error.retryModal.onRetry',
                              'error.retryModal.onCancel',
                          ],
                      }
                    : false,
        }),
})

// Export RootState type for use throughout the application
export type RootState = ReturnType<typeof store.getState>

// Export AppDispatch type for typed dispatch
export type AppDispatch = typeof store.dispatch
